var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "shape-newsletter-curved-top",
  "use": "shape-newsletter-curved-top-usage",
  "viewBox": "0 0 704 111",
  "content": "<symbol viewBox=\"0 0 704 111\" id=\"shape-newsletter-curved-top\"><path d=\"M704 110.316c-.013-23.737-42.641-60-96-60-50.212 0-70.198 24-120 24-83.532 0-125.807-60-232-60-94.675 0-183.961 38.657-256 91.368V0h704v110.316\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-sprite/shape-newsletter-curved-top.svg
// module id = 276
// module chunks = 114276838955818